import React, {useEffect} from "react";
import _ from "../Trans";
import ReactGA from "react-ga4";
import Config from "../Config";

export default function Rules({
                                  title = "Rules",
                                  url = '/rules-react/',
                                  ga_url = '/rules/'
                              }) {
    const supermanagerIframeRulesUrl = process.env.REACT_APP_PUBLIC_URL + url

    useEffect(() => {
        const rulesTitle = _(title)
        ReactGA.initialize(Config.GA_CODE);
        ReactGA.send({hitType: "pageview", page: ga_url, title: rulesTitle});
    }, []);

    return (
        <iframe src={supermanagerIframeRulesUrl}
                title={title}
                className="mb-5 pb-5 w-100 h-100 rules"
        >
        </iframe>
    )
}